import { Routes } from '@angular/router';
import { ReferentialsNaturesComponent } from './features/parameters/referentials/referentials-natures/referentials-natures.component';
import { ReferentialsUnitsComponent } from './features/parameters/referentials/referentials-units/referentials-units.component';
import { isAuthenticatedGuard } from './core/guards/is-authenticated.guard';
import { isLoggedGuard } from './core/guards/is-logged.guard';
import { ReferentialsConditionnementsComponent } from './features/parameters/referentials/referentials-conditionnements/referentials-conditionnements.component';
import { ReferentialsAdrComponent } from './features/parameters/referentials/referentials-adr/referentials-adr.component';
import { ReferentialsCedComponent } from './features/parameters/referentials/referentials-ced/referentials-ced.component';
import { ReferentialsImmobilisationDemandeComponent } from './features/parameters/referentials/referentials-immobilisation-demande/referentials-immobilisation-demande.component';
import { ReferentialsAnnulationDemandeComponent } from './features/parameters/referentials/referentials-annulation-demande/referentials-annulation-demande.component';
import { ReferentialsPrestationsComponent } from './features/parameters/referentials/referentials-prestations/referentials-prestations.component';
import { isAuthorizedGuard } from './core/guards/is-authorized.guard';
import { ReferentialsOutilAchatComponent } from './features/parameters/referentials/referentials-outil-achat/referentials-outil-achat.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    canActivate: [isAuthorizedGuard],
    loadComponent: () => import('./features/login-page/login-page.component').then((m) => m.LoginPageComponent),
  },
  {
    path: 'sso',
    canActivate: [isAuthorizedGuard],
    loadComponent: () => import('./features/login-page/login-page.component').then((m) => m.LoginPageComponent),
  },
  {
    path: 'callback',
    canActivate: [isAuthorizedGuard],
    loadComponent: () => import('./features/login-page/auth-callback/auth-callback.component').then((m) => m.AuthCallbackComponent),
  },
  {
    path: 'select-contract',
    canActivate: [isLoggedGuard],
    loadComponent: () => import('./features/contracts/select-contract/select-contract.component').then((m) => m.SelectContractComponent),
  },
  {
    path: 'contact',
    loadComponent: () => import('./core/components/contact/contact.component').then((m) => m.ContactComponent),
  },
  {
    path: 'legal-notices',
    loadComponent: () => import('./core/components/legal-notices/legal-notices.component').then((m) => m.LegalNoticesComponent),
  },
  {
    path: 'home',
    canActivate: [isAuthenticatedGuard],
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'producers-wastes',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/grid/producers-wastes/producers-wastes.component').then((m) => m.ProducersWastesComponent),
  },
  {
    path: 'suppliers',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/grid/suppliers/suppliers.component').then((m) => m.SuppliersComponent),
  },
  {
    path: 'price-list',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/grid/price-list/price-list.component').then((m) => m.PriceListComponent),
  },  
  {
    path: 'mass-price',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/grid/transport-mass-price/transport-mass-price.component').then((m) => m.TransportMassPriceComponent),
  },
  {
    path: 'demand-prestations',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/demands/demand-prestations/demand-prestations.component').then((m) => m.DemandPrestationsComponent),
  },
  {
    path: 'prestations-completed',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/prestations/prestations-completed/prestations-completed.component').then((m) => m.PrestationsCompletedComponent),
  },
  {
    path: 'integrate-services',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/prestations/integrate-services/integrate-services.component').then((m) => m.IntegrateServicesComponent),
  },
  {
    path: 'purchase-orders',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/prestations/purchase-orders/purchase-orders.component').then((m) => m.PurchaseOrdersComponent),
  },
  {
    path: 'billing-preparation',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/billing/billing-preparation/billing-preparation.component').then((m) => m.BillingPreparationComponent),
  },
  {
    path: 'customer-control',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/billing/customer-control/customer-control.component').then((m) => m.CustomerControlComponent),
  },
  {
    path: 'technical-reports',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/billing/technical-reports/technical-reports.component').then((m) => m.TechnicalReportsComponent),
  },
  {
    path: 'reporting',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/billing/reporting/reporting.component').then((m) => m.ReportingComponent),
  },
  {
    path: 'contracts',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/parameters/contracts/contracts.component').then((m) => m.ContractsComponent),
  },
  {
    path: 'users',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/parameters/users/users.component').then((m) => m.UsersComponent),
  },
  {
    path: 'tgap',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/parameters/tgap/tgap.component').then((m) => m.TgapComponent),
  },
  {
    path: 'password-update',
    canActivate: [isAuthenticatedGuard],
    loadComponent: () => import('./features/password-update/password-update.component').then((m) => m.PasswordUpdateComponent),
  },
  {
    path: 'majMotDePasse/reset',
    loadComponent: () => import('./features/password-update/password-update.component').then((m) => m.PasswordUpdateComponent),
  },
  {
    path: 'password-obsolete',
    loadComponent: () => import('./features/password-update/password-update.component').then((m) => m.PasswordUpdateComponent),
  },
  {
    path: 'referentials',
    canActivate: [isAuthenticatedGuard, isAuthorizedGuard],
    loadComponent: () => import('./features/parameters/referentials/referentials.component').then((m) => m.ReferentialsComponent),
    children: [
      {
        path: '',
        redirectTo: 'natures',
        pathMatch: 'full', // Redirige vers natures par défaut
      },
      {
        path: 'natures',
        component: ReferentialsNaturesComponent,
      },
      {
        path: 'conditionnements',
        component: ReferentialsConditionnementsComponent,
      },
      {
        path: 'prestations',
        component: ReferentialsPrestationsComponent,
      },
      {
        path: 'immobilisation-demande',
        component: ReferentialsImmobilisationDemandeComponent,
      },
      {
        path: 'annulation-demande',
        component: ReferentialsAnnulationDemandeComponent,
      },
      {
        path: 'adr',
        component: ReferentialsAdrComponent,
      },
      {
        path: 'ced',
        component: ReferentialsCedComponent,
      },
      {
        path: 'units',
        component: ReferentialsUnitsComponent,
      },
      {
        path: 'outil-achat',
        component: ReferentialsOutilAchatComponent,
      },
    ],
  },
  {
    path: 'configuration',
    canActivate: [isAuthenticatedGuard],
    loadComponent: () => import('./features/parameters/configuration/configuration.component').then((m) => m.ConfigurationComponent),
  },
];
